<template>
    <div style="position: relative; height: calc(100vh - 60px); padding: 40px 4vw 0 4vw;">
        <div class="guide-links row no-wrap">
            <div class="guide-link" @click="showKnowledgeGuide = true">Knowledge Guide</div>
        </div>

        <div style="max-width: 900px;">
            <div style="color: #ff4e00; font-size: 12px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;">Agentic next-best-action</div>
            <div class="q-mt-sm" style="font-size: 21px; line-height: 30px; font-weight: 600;">Discover Smarter Opportunities. Generate Better Recommendations. Drive Field Impact.</div>
            <div class="q-my-md" style="color: #555555; font-size: 16px; line-height: 1.6;">NBA Agents help teams proactively identify and shape new use cases, translate opportunities into intelligent Next-Best-Action recommendations, and continuously optimize recommendations based on field outcomes.</div>
            <div style="color: #ff4e00; font-size: 14px; line-height: 1.55; font-weight: 600;">Discover Use Cases <span class="text-black q-mx-sm">→</span> Design & Prioritize <span class="text-black q-mx-sm">→</span> Generate NBA <span class="text-black q-mx-sm">→</span> Activate <span class="text-black q-mx-sm">→</span> Measure & Learn</div>
        </div>

        <div class="workspace-grid q-mt-lg" aria-label="Decision engine workspaces">
            <div class="workspace-card" @click="navigateTo('opportunity-hub')">
                <div class="icon-tile target-icon" aria-hidden="true">
                    <svg viewBox="0 0 42 42" role="img" focusable="false">
                        <circle cx="21" cy="21" r="12.5" fill="none" stroke="currentColor" stroke-width="2.5" />
                        <circle cx="21" cy="21" r="7" fill="none" stroke="currentColor" stroke-width="2.5" />
                        <circle cx="21" cy="21" r="3" fill="currentColor" />
                    </svg>
                </div>

                <div class="q-mt-md" style="font-size: 18px; font-weight: 700;">NBA Opportunity Hub</div>

                <div class="q-my-sm" style="color: #5d5d5d; font-size: 14px; line-height: 1.55;">Discover, shape and prioritize high-value NBA use cases with agent assistance.</div>

                <footer>
                    <div>From opportunity to NBA-ready use cases</div>
                    <button type="button">Open <span>→</span></button>
                </footer>
            </div>

            <div class="workspace-card" @click="navigateTo('agent-studio')">
                <div class="icon-tile running-icon" aria-hidden="true">
                    <svg viewBox="0 0 42 42" role="img" focusable="false">
                        <path d="M8 12.5h22M8 21h22M8 29.5h15" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.5" />
                        <circle cx="28" cy="29.5" r="3.5" fill="currentColor" />
                    </svg>
                </div>

                <div class="q-mt-md" style="font-size: 18px; font-weight: 700;">NBA Agent Studio</div>

                <div class="q-my-sm" style="color: #5d5d5d; font-size: 14px; line-height: 1.55;">Generate personalized, explainable Next-Best-Action recommendations.</div>

                <footer>
                    <div>Explainable recommendations, ready to activate</div>
                    <button type="button">Open <span>→</span></button>
                </footer>
            </div>

            <div class="workspace-card" @click="navigateTo('impact-center')">
                <div class="icon-tile chart-icon" aria-hidden="true">
                    <svg viewBox="0 0 42 42" role="img" focusable="false">
                        <path d="M12 10v21h21M18 27V17M24 27V11M30 27v-7" fill="none" stroke="currentColor" stroke-linecap="square" stroke-width="2.5" />
                    </svg>
                </div>

                <div class="q-mt-md" style="font-size: 18px; font-weight: 700;">NBA Impact Center</div>

                <div class="q-my-sm" style="color: #5d5d5d; font-size: 14px; line-height: 1.55;">Measure field impact and feed learnings back to improve use cases and recommendations.</div>

                <footer>
                    <div>Measure impact. Learn. Optimize.</div>
                    <button type="button">Open <span>→</span></button>
                </footer>
            </div>
        </div>

        <KnowledgeGuide v-model="showKnowledgeGuide"/>
    </div>
</template>

<script>
import KnowledgeGuide from '@/components/KnowledgeGuide.vue';

export default {
    name: "HomeView",

    components: {
        KnowledgeGuide,
    },

    data() {
        return {
            showKnowledgeGuide: false,
        };
    },
    
    methods: {
        navigateTo(route) {
            try {
                this.$router.push({ name: route });
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>

<style scoped>

.guide-links {
    position: absolute;
    top: 16px;
    right: 4vw;
}

.guide-link {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #ff4e00;
    text-decoration: underline;
    white-space: nowrap;
}

.guide-link:hover {
    color: #b33700;
}

.intro {
    max-width: 800px;
}


.intro-copy {
    max-width: 700px;
    margin: 0 0 22px;
    color: #555555;
    font-size: 16px;
    line-height: 1.6;
}

.workspace-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;
}

.workspace-card {
    display: grid;
    grid-row: span 4;
    grid-template-rows: subgrid;
    row-gap: 0;
    cursor: pointer;
    padding: 26px;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 12px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.workspace-card:hover {
    border-color: #ff4e00;
}

.icon-tile {
    width: 42px;
    height: 42px;
    padding: 4px;
    display: grid;
    place-items: center;
    border-radius: 6px;
    background: #fff0ea;
    color: #ff4e00;
}

.icon-tile svg {
    width: 100%;
    height: 100%;
}

footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin: 0 -26px -26px;
    padding: 12px 20px 12px 26px;
    border-top: 1px solid #d7d7d7;
    color: #6b6b6b;
    font-size: 13px;
}

footer > div {
    min-width: 0;
}

footer strong {
    color: #1f1f1f;
}

button {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #ff4e00;
    cursor: pointer;
    font: inherit;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
}

button span {
    margin-left: 3px;
}

button:hover {
    text-decoration: underline;
}

@media (max-width: 900px) {
    .workspace-grid {
        grid-template-columns: 1fr;
    }
}
</style>
